export default __webpack_public_path__ + "static/media/frame-6.de7bb3ca.png";